import { DialogProps } from '@radix-ui/react-dialog';
import { Spinner } from 'components/spinner';
import dynamic from 'next/dynamic';

export const CarrelloDialogVenditaSuccess = dynamic<DialogProps>(
  () =>
    import('features/carrello/carrelloDialogVenditaSuccess/CarrelloDialogVenditaSuccess').then(
      (mod) => mod.CarrelloDialogVenditaSuccess
    ),
  { loading: () => <Spinner className={'sportDialogVenditaSuccess'} />, ssr: false }
);
